// An error the host has already turned into a screen of its own; the module paints nothing for it.
// The host decides which errors those are, so the module stays free of permissions and wire codes.
export type IsHandledByHost = (error: unknown) => boolean;

// The default: every error is the module's to show, as before a host passes anything.
export const neverHandledByHost: IsHandledByHost = () => false;
